/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { useWatch } from 'react-hook-form';

const Container = styled.div`
    margin-top: 1em;
`;

function TotalPrice() {
    const items = useWatch({ name: 'items' }) || [];
    const total = items
        .reduce(
            (sum, item) =>
                sum + (item.quantity || 0) * (Number(item.price) || 0),
            0,
        )
        .toFixed(2);

    return (
        <Container>
            <FormattedMessage
                id="pages.appointments.cart.form.totalPrice"
                defaultMessage="Total price"
            />: &euro; {total}
        </Container>
    );
}

export default TotalPrice;
